import React from 'react';
import { useState, useEffect } from "react";
import { Grid } from '@mui/material';
import { useHistory } from "react-router-dom";
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import { first } from 'lodash';
import InputMask from 'react-input-mask';
import dayjs from 'dayjs';
const Search = () => {
    const history = useHistory();
    const INACTIVE_EVENT_MESSAGE = 'The previously selected event is no longer active. Please select another active event.';
    // ** States   
    const [hasResult, setHasResult] = useState(true);
    const [eventName, setEventName] = useState(localStorage.getItem('defaultEventName') ?? '');
    const [error, setError] = useState(null);
    const [createUser, setCreateUser] = useState(false);
    const [openProgressBar, setOpenProgressBar] = useState(false);
    const [showAllCriteria, setShowAllCriteria] = useState(false);
    const handleCloseProgressBar = () => {
        setOpenProgressBar(false);
    };

    const redirectToNoEventIfInactive = async () => {
        const defaultEventId = localStorage.getItem('defaultEventId');
        if (!defaultEventId || defaultEventId.trim() === "") {
            localStorage.setItem('eventInactiveMessage', INACTIVE_EVENT_MESSAGE);
            history.push('/NoEvent');
            return true;
        }

        try {
            const response = await fetch(`/api/Event/GetEventById?id=${defaultEventId}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('JWTToken')}`,
                    'Content-Type': 'application/json'
                }
            });
            const data = await response.json();
            const eventEndDate = data?.events?.$values?.[0]?.eventEndDate;

            if (!eventEndDate || dayjs(eventEndDate).isBefore(dayjs().startOf('day'))) {
                localStorage.setItem('defaultEventId', "");
                localStorage.setItem('eventInactiveMessage', INACTIVE_EVENT_MESSAGE);
                history.push('/NoEvent');
                return true;
            }
        } catch (ex) {
            localStorage.setItem('eventInactiveMessage', INACTIVE_EVENT_MESSAGE);
            history.push('/NoEvent');
            return true;
        }

        return false;
    };

    const handleNotExistedNoRequiredChange = async () => {
        if (await redirectToNoEventIfInactive()) {
            return;
        }

        let phoneNumber = document.querySelector('input[placeholder="Enter Phone Number"]')?.value ?? '';
        phoneNumber = phoneNumber.replace(/\D/g, '');
        history.push({ pathname: '/AdjusterInfoEntry', state: { data: { noSearchFound: "No user found with phone number: " + phoneNumber, phoneNumber: phoneNumber } } });
    }

    const handleNotExistedChange = async () => {
        if (await redirectToNoEventIfInactive()) {
            return;
        }

        const firstName = document.querySelector('input[placeholder="Enter First Name"]')?.value ?? '';
        const lastName = document.querySelector('input[placeholder="Enter Last Name"]')?.value ?? '';
        const email = document.querySelector('input[placeholder="Enter Email"]')?.value ?? '';
        let phoneNumber = document.querySelector('input[placeholder="Enter Phone Number"]')?.value ?? '';
        phoneNumber = phoneNumber.replace(/\D/g, '');

        const params = {
            firstName,
            phoneNumber,
            lastName,
            email
        };

        if (firstName && lastName && phoneNumber && email) {
            handleAddUser(params);
        } else {
            setError("Please fill in all fields.");
        }
    }

    const handleAddUser = async (params) => {
        if (await redirectToNoEventIfInactive()) {
            return;
        }

        setHasResult(false);
        setOpenProgressBar(true);
        setError(null);
        fetch(`/api/Adjuster/PostNewTempUser`, {
            method: 'POST',
            body: JSON.stringify({
                "FirstName": params.firstName,
                "LastName": params.lastName,
                "PhoneNumber": params.phoneNumber,
                "Email": params.email,
            }),
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('JWTToken')}`,
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then((data) => {
                if (JSON.stringify(data).length > 0) {
                    setHasResult(true);
                    //setData({ ...params, userId: data.tempUserId, count: -1 });
                    history.push({ pathname: '/Verification', state: { data: { ...params, userId: data.tempUserId, count: -1 } } });
                }
                else {
                    setError("No results found");
                    setCreateUser(true);
                }
                setOpenProgressBar(false);
            })
            .catch((error) => {
                if (error.message.includes("No user")) {
                    setError("No user found with adjuster Id: " + params.pilotId);
                }
                else if (error.message.includes("Unauthorized")) {
                    history.push('/noevent');
                }
                else {
                    setError("An error occurred, please try again later");
                }
                setOpenProgressBar(false);
            });
    }

    const handlePilotIdSearchChange = async () => {
        if (await redirectToNoEventIfInactive()) {
            return;
        }

        const pilotId = document.querySelector('input[placeholder="Enter Pilot ID"]')?.value ?? '';

        if (pilotId) {
            fetchPilotIdSearch(pilotId);
        } else {
            setError("Pilot ID is required.");
        }
    }

    const fetchPilotIdSearch = async (pilotId) => {
        if (await redirectToNoEventIfInactive()) {
            return;
        }

        setOpenProgressBar(true);
        setError(null);

        fetch(`/api/Adjuster/GetExistingUserByAdjusterId?adjusterId=${pilotId}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('JWTToken')}`,
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                if (response.ok) {
                    return response.json();
                } else if (response.status === 400) {
                    // will succeed if the server will always respond with JSON with a 400 response

                    return response.text().then((errorData) => {
                        setError(errorData || "An error occurred, please try again later.");
                        throw new Error(errorData || "An error occurred, please try again later.");
                    });

                } else {
                    // there was some other error in the response, such as status 500
                    const error = new Error(response.statusText);
                    setError(error.message);
                    return Promise.reject(error);
                }
            })
            .then((data) => {
                if (JSON.stringify(data).length > 0) {
                    setHasResult(true);
                    history.push({ pathname: '/Verification', state: { data: data } });
                } else {
                    setError("No results found");
                    setCreateUser(true);
                }
                setOpenProgressBar(false);
            })
            .catch((error) => {
                if (error.message.includes("No user")) {
                    setError("No user found with adjuster ID " + pilotId);
                } else if (error.message.includes("Unauthorized")) {
                    history.push('/noevent');
                }
                else {
                    setError("An error occurred, please try again later.");
                }
                setOpenProgressBar(false);
            });
    }

    const handleSearchChange = async () => {
        if (await redirectToNoEventIfInactive()) {
            return;
        }

        const firstName = document.querySelector('input[placeholder="Enter First Name"]')?.value ?? '';
        const lastName = document.querySelector('input[placeholder="Enter Last Name"]')?.value ?? '';
        const email = document.querySelector('input[placeholder="Enter Email"]')?.value ?? '';
        let phoneNumber = document.querySelector('input[placeholder="Enter Phone Number"]')?.value ?? '';
        phoneNumber = phoneNumber.replace(/\D/g, '');
        const params = {
            phoneNumber,
            firstName,
            lastName,
            email
        };

        if (firstName && lastName && phoneNumber && email) {
            fetchCombinedSearch(params);
        } else {
            setError("All fields are required.");
        }
    };

    const handleSearchByPhoneChange = async () => {
        if (await redirectToNoEventIfInactive()) {
            return;
        }

        setOpenProgressBar(true);
        setError(null);
        let phoneNumber = document.querySelector('input[placeholder="Enter Phone Number"]')?.value ?? '';
        phoneNumber = phoneNumber.replace(/\D/g, '');
        fetch(`/api/Adjuster/GetExistingUserByPhoneNum?phoneNum=${phoneNumber}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('JWTToken')}`,
                'Content-Type': 'application/json',
            }
        })
            .then(response => {
                if (response.ok) {
                    return response.json();
                } else if (response.status === 400) {
                    // will succeed if the server will always respond with JSON with a 400 response

                    return response.text().then((errorData) => {
                        setError(errorData || "An error occurred, please try again later.");
                        throw new Error(errorData || "An error occurred, please try again later.");
                    });

                } else {
                    // there was some other error in the response, such as status 500
                    const error = new Error(response.statusText);
                    setError(error.message);
                    return Promise.reject(error);
                }
            })
            .then((data) => {
                if (JSON.stringify(data).length > 0) {
                    setHasResult(true);
                    history.push({ pathname: '/Verification', state: { data: data } });
                } else {
                    setError("No results found");
                    setCreateUser(true);
                }
                setOpenProgressBar(false);
            })
            .catch((error) => {
                console.log("Error fetching data: ", error.message);
                if (error.message.includes("No user")) {
                    history.push({ pathname: '/Verification', state: { data: { noSearchFound: "No user found with phone number: " + phoneNumber, phoneNumber: phoneNumber } } });
                    //setError("No user found with phone number: " + phoneNumber);
                } else if (error.message.includes("Unauthorized")) {
                    history.push('/noevent');
                }
                else {
                    setError("An error occurred, please try again later.");
                }
                setOpenProgressBar(false);
            });

    }

    const fetchCombinedSearch = async (params) => {
        if (await redirectToNoEventIfInactive()) {
            return;
        }

        setOpenProgressBar(true);
        setError(null);
        fetch(`/api/Adjuster/GetExistingUserByAllFieldsList?${new URLSearchParams(params).toString()}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('JWTToken')}`,
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then((data) => {
                if (JSON.stringify(data).length > 0) {
                    setHasResult(true);
                    history.push({ pathname: '/Verification', state: { data: data } });
                }
                else {
                    setError("No results found");
                    setCreateUser(true);
                }
                setOpenProgressBar(false);
            })
            .catch((error) => {
                if (error.message.includes("No user")) {
                    setError("No user found with adjuster ID: " + params.pilotId);
                }
                else if (error.message.includes("Unauthorized")) {
                    history.push('/noevent');
                }
                else {
                    setError("An error occurred, please try again later");
                }
                setOpenProgressBar(false);
            });
    }

    const validateEmail = (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(String(email).toLowerCase());
    };


    useEffect(() => {
        const initializeSearchPage = async () => {
        localStorage.getItem('EventSearchBy');
        if ((localStorage.getItem('EventSearchBy') ?? '') === "pilotIdOrPhone") {
            setShowAllCriteria(false);
        } else {
            setShowAllCriteria(true);
        }

        await redirectToNoEventIfInactive();
        };

        initializeSearchPage();

        // get the event that is currently running and set its name 
        // used to display event name in the page header 
        const defaultEventId = localStorage.getItem('defaultEventId');
        if (defaultEventId) {
            fetch(`/api/Event/GetEventById?id=${defaultEventId}`, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('JWTToken')}`,
                    'Content-Type': 'application/json'
                }
            })
                .then(res => res.json())
                .then(data => {
                    // event name is cached so it loads faster
                    const name = data?.events?.$values[0]?.eventName;
                    if (name) {
                        setEventName(name);
                        localStorage.setItem('defaultEventName', name);
                    }
                })
                .catch(() => {});
        }
    }, [history]);

    return (
        <>
            <Grid container spacing={3} justifyContent="center">
                <Grid item xs={11} md={11}>
                    <div className="bg-white rounded-lg p-8 space-y-4 flex flex-col shadow-2xl">
                        <div className="bg-white max-w-xl mx-auto">
                            <div className="text-center max-w-md mx-auto space-y-2 p-4">
                                <h1 className="text-2xl font-bold">{eventName || 'Loading...'}</h1>
                                <h3 className="text-lg font-bold">PLEASE CHECK IN BELOW</h3>
                                
                            </div>
                            <div className="flex flex-col sm:flex-row items-top sm:justify-between">
                                <div className="flex flex-col items-center mb-4 sm:mb-0 sm:mr-0">
                                    <label htmlFor="pilotId" className="block text-gray-700 mb-2">Pilot ID:</label>
                                    <input type="text" id="pilotId" placeholder="Enter Pilot ID" className="border border-gray-300 rounded p-2 mb-4 w-48" maxLength="7" onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')} inputMode="numeric" />
                                    <button className="bg-red-900 text-white rounded-full px-16 py-2" onClick={handlePilotIdSearchChange}>Search</button>
                                </div>
                                <div className="flex items-center ">
                                    <Divider orientation="vertical" flexItem>OR</Divider>
                                    {showAllCriteria ?
                                        <>
                                            <div className="flex flex-col">
                                                <div className="flex flex-row justify-between mb-4">
                                                    <div className="mr-4">
                                                        <label htmlFor="firstName" className="block text-gray-700 mb-2">First Name:<span style={{ color: 'red' }}>*</span></label>
                                                        <input type="text" id="firstName" placeholder="Enter First Name" className="border border-gray-300 rounded p-2 w-48" />
                                                    </div>
                                                    <div>
                                                        <label htmlFor="lastName" className="block text-gray-700 mb-2">Last Name:<span style={{ color: 'red' }}>*</span></label>
                                                        <input type="text" id="lastName" placeholder="Enter Last Name" className="border border-gray-300 rounded p-2 w-48" />
                                                    </div>
                                                </div>
                                                <div className="flex flex-row justify-between mb-4">
                                                    <div className="mr-4">
                                                        <label htmlFor="cellPhone" className="block text-gray-700 mb-2">Phone Number:<span style={{ color: 'red' }}>*</span></label>
                                                        <InputMask
                                                            mask="(999) 999-9999"
                                                            maskChar=""
                                                        >
                                                            {(inputProps) => (
                                                                <input
                                                                    {...inputProps}
                                                                    type="text"
                                                                    id="cellPhone"
                                                                    placeholder="Enter Phone Number"
                                                                    className="border border-gray-300 rounded p-2 w-48"
                                                                    inputMode="numeric"
                                                                />
                                                            )}
                                                        </InputMask>
                                                    </div>
                                                </div>
                                                <div className="flex flex-row justify-between mb-4">
                                                    <div>
                                                        <label htmlFor="email" className="block text-gray-700 mb-2">Email:<span style={{ color: 'red' }}>*</span></label>
                                                        <input type="text" id="email" placeholder="Enter Email" className="border border-gray-300 rounded p-2 relative w-full min-w-[400px]" />
                                                    </div>
                                                </div>
                                                <div className="flex flex-col sm:flex-row justify-between">
                                                    <button className="bg-red-900 text-white rounded-full px-16 py-2 mb-2 sm:mb-0" onClick={() => {
                                                        const email = document.getElementById('email').value;
                                                        const cellPhoneRaw = document.getElementById('cellPhone').value;
                                                        const cellPhone = cellPhoneRaw.replace(/\D/g, '');
                                                        if (!validateEmail(email)) {
                                                            setError("Please enter a valid email address.");
                                                        } else if (cellPhone.length !== 10 || isNaN(cellPhone)) {
                                                            setError("Please enter a valid 10-digit cell phone number.");
                                                        } else {
                                                            handleSearchChange();
                                                        }
                                                    }}>Search</button>
                                                    <button className="bg-black text-white rounded-full px-16 py-2 mb-2 sm:mb-0" onClick={handleNotExistedChange}>Create User</button>
                                                </div>
                                            </div>
                                        </>
                                        :
                                        <>
                                            <div className="flex flex-col">
                                                <div className="flex flex-row justify-between mb-4">
                                                    <div className="mr-4">
                                                        <label htmlFor="cellPhone" className="block text-gray-700 mb-2">Phone Number:</label>
                                                        <InputMask
                                                            mask="(999) 999-9999"
                                                            maskChar=""
                                                        >
                                                            {(inputProps) => (
                                                                <input
                                                                    {...inputProps}
                                                                    type="text"
                                                                    id="cellPhone"
                                                                    placeholder="Enter Phone Number"
                                                                    className="border border-gray-300 rounded p-2 w-48"
                                                                    inputMode="numeric"
                                                                />
                                                            )}
                                                        </InputMask>
                                                    </div>
                                                </div>
                                                <div className="flex flex-col sm:flex-row justify-between">
                                                    <button className="bg-red-900 text-white rounded-full px-16 py-2 mb-2 sm:mb-0" onClick={() => {
                                                        const cellPhoneRaw = document.getElementById('cellPhone').value;
                                                        const cellPhone = cellPhoneRaw.replace(/\D/g, '');
                                                        if (cellPhone.length !== 10) {
                                                            setError("Please enter a valid 10-digit cell phone number.");
                                                        } else {
                                                            handleSearchByPhoneChange();
                                                        }
                                                    }}>Search</button>
                                                </div>
                                            </div>
                                        </>
                                    }
                                </div>
                            </div>
                            {!showAllCriteria &&
                                <div className="text-center max-w-md mx-auto space-y-4 p-4">
                                    <button className="bg-black text-white rounded-full px-16 py-2 mb-2 sm:mb-0" onClick={handleNotExistedNoRequiredChange}>Create User</button>
                                </div>
                            }
                        </div>
                        <div className="flex justify-center">
                            {error && <div className="text-red-500">{error}</div>}
                        </div>
                        <div>
                            {createUser &&
                                <div className="flex justify-center">
                                    <button className="bg-red-900 text-white rounded-full px-16 py-2" onClick={handleSearchChange}>
                                        <div className="flex space-x-2">
                                            <div><ControlPointIcon /></div>
                                            <div>Create User</div>
                                        </div>
                                    </button>
                                </div>
                            }
                        </div>
                    </div>                    
                </Grid>

            </Grid>
            <Backdrop
                open={openProgressBar}
                onClick={handleCloseProgressBar}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
};

export default Search;